import { Component, OnInit } from '@angular/core';
import {GlobalService} from "../../../../global.service";
import {EventsService} from "../../../events.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-winter-wonder-tournaments',
  templateUrl: './winter-wonder-tournaments.component.html',
  styleUrls: ['./winter-wonder-tournaments.component.css']
})
export class WinterWonderTournamentsComponent implements OnInit {

  constructor(public globalService: GlobalService, public eventService: EventsService, private activeRoute: ActivatedRoute) { }

  ngOnInit() {
    this.activeRoute.params.subscribe(param => {
      this.changeRoute(param['code']);
    });
  }
  changeRoute(param) {
    this.eventService.loadEventTournaments = true;
    this.eventService.getEventTournaments('winter-wonder', 1, param).subscribe(res => {
      this.eventService.eventTournaments.next(res);
      this.eventService.loadEventTournaments = false;
    },error=>this.eventService.loadEventTournaments = false)
  }
}
